import { ApiService } from '@/shared/services/api.service';
import { BreakoutRoomEventRouter } from '../events/BreakoutRoomEventRouter';
import { GlobalEventService } from '@/host/services/event.service';

export interface CreateBreakoutRoomRequest {
  mainRoomId: string;
  durationMinutes: number;
  creatorUserPid: string;
  metadata?: any;
}

export interface CreateBreakoutRoomGroupRequest {
  mainRoomId: string;
  roomCount: number;
  roomNamePrefix: string;
  durationMinutes: number;
  creatorUserPid: string;
  metadata?: any;
}

export class BreakoutRoomService {
  private baseUrl = '/breakout-rooms';
  constructor() {
    this.eventRouter.registerEventListeners();
  }
  destroy() {
    this.eventRouter.unregisterEventListeners();
  }
  private eventRouter: BreakoutRoomEventRouter = new BreakoutRoomEventRouter(GlobalEventService);
  /**
   * Create a single breakout room
   */

  //static async
  async createBreakoutRoom(request: CreateBreakoutRoomRequest, payload: any): Promise<void> {
    try {
      const response = await ApiService.post<any>(this.baseUrl, payload);
      request.metadata.users.forEach((userPid: string) => {
        payload.rooms.forEach((room: any) => {
          if (room.users.includes(userPid)) {
            this.eventRouter.sendBreakoutSessionCreatedEvent(userPid, {
              breakoutRoomJid: room.jitsiRoomJid,
            });
          }
        });
      });
      return response;
    } catch (error: any) {
      console.error('Failed to create breakout room:', error.response?.data || error);
      throw error;
    }
  }

  async getBreakoutRoomsForMainRoom(mainRoomId: string): Promise<any> {
    try {
      const response = await ApiService.get<any>(`${this.baseUrl}/${mainRoomId}`);
      return response;
    } catch (error: any) {
      console.error('Failed to fetch breakout rooms:', error.response?.data || error);
    }
    return null;
  }

  async endSession(jitsiRoomId: string, users: string[]): Promise<void> {
    try {
      await ApiService.post(`${this.baseUrl}/close`, { roomId: jitsiRoomId });
      users.forEach((userPid: string) => {
        this.eventRouter.sendBreakoutSessionEndedEvent(userPid, { mainRoomJid: jitsiRoomId });
      });
    } catch (error: any) {
      console.error('Failed to end breakout session:', error.response?.data || error);
    }
  }

  async endAllSessions(mainRoomId: string, mainRoomJid: string, users: string[]): Promise<void> {
    try {
      await ApiService.post(`${this.baseUrl}/closemainroom`, { mainRoomId });

      users.forEach((userPid: string) => {
        this.eventRouter.sendBreakoutSessionEndedEvent(userPid, { mainRoomJid: mainRoomJid });
      });
      console.log('Ended all breakout sessions for main room:', mainRoomId);
    } catch (error: any) {
      console.error('Failed to end all breakout sessions:', error.response?.data || error);
    }
  }
}
